var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRocketLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7576 23.0711C10.3434 27.3137 4.68652 27.3137 4.68652 27.3137C4.68652 27.3137 4.68652 21.6569 8.92916 20.2426",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4854 13.1716L16.0001 21.6569L10.3433 16L18.8285 7.51472C22.0416 4.3017 25.2546 4.33304 26.6248 4.53749C26.8358 4.56894 27.0311 4.66733 27.182 4.81816C27.3328 4.96899 27.4312 5.16429 27.4626 5.37527C27.6671 6.74554 27.6984 9.95855 24.4854 13.1716Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0711 14.5858V22.6569C23.0711 22.7882 23.0452 22.9182 22.9949 23.0395C22.9447 23.1609 22.871 23.2711 22.7782 23.364L18.7355 27.4067C18.6075 27.5347 18.4471 27.6255 18.2716 27.6695C18.096 27.7136 17.9118 27.7091 17.7386 27.6567C17.5653 27.6042 17.4096 27.5057 17.2879 27.3717C17.1663 27.2377 17.0833 27.0732 17.0478 26.8957L16 21.6569",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4141 8.92893H9.34301C9.21169 8.92893 9.08166 8.9548 8.96033 9.00505C8.839 9.05531 8.72876 9.12897 8.63591 9.22182L4.59319 13.2645C4.4652 13.3925 4.37435 13.5529 4.33033 13.7284C4.2863 13.904 4.29075 14.0882 4.3432 14.2614C4.39565 14.4347 4.49414 14.5904 4.62815 14.7121C4.76217 14.8337 4.92669 14.9167 5.10418 14.9522L10.343 16",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketLaunch);
export default __webpack_public_path__ + "static/media/RocketLaunch.1ed7072caefbf067fde82bbf7dd5b679.svg";
export { ForwardRef as ReactComponent };